document.addEventListener('DOMContentLoaded', function() {
    const mapElements = document.querySelectorAll('.acf-map');
    
    if (!mapElements.length) return;
    
    mapElements.forEach(mapElement => {
        const lat = parseFloat(mapElement.getAttribute('data-lat'));
        const lng = parseFloat(mapElement.getAttribute('data-lng'));
        const zoom = parseInt(mapElement.getAttribute('data-zoom')) || 16;
    
        // Initialize Google Map
        const map = new google.maps.Map(mapElement, {
            zoom: zoom,
            mapId: '41ab86690a62b5f3aaa1ec14',
            center: {
                lat: lat,
                lng: lng
            },
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
        });
        
        // Add marker at the location
        const markerIcon = mapElement.getAttribute('data-marker-icon');
        const markerImg = mapElement.getAttribute('data-imgUrl');
        const title = mapElement.getAttribute('data-title');
        const address = mapElement.getAttribute('data-address');
        const phone = mapElement.getAttribute('data-phone');

        const marker = new google.maps.Marker({
            position: { lat, lng },
            map: map,
            icon: markerIcon ? {
                url: markerIcon,
                scaledSize: new google.maps.Size(80, 80),
            } : undefined,
        });

        const infoWindow = new google.maps.InfoWindow({
            content: `
                <div>
                    ${markerImg ? `<div class="infowindow-img"><img src="${markerImg}" alt="${title}"></div>` : ''}
                    <div class="infowindow-content">
                        ${title ? `<h2>${title}</h2>` : ''}
                        ${phone ? `<div class="infowindow-detail"><div class="infowindow-detail-img"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.563" d="m21.138 17.152-4.804.931c-3.245-1.629-5.25-3.5-6.417-6.416l.899-4.819-1.699-4.515H4.741c-1.315 0-2.351 1.087-2.154 2.388.49 3.247 1.936 9.135 6.164 13.362 4.439 4.44 10.833 6.366 14.352 7.132 1.359.296 2.564-.765 2.564-2.155v-4.182z"/></svg></div><p><a href="tel:${phone}">${phone}</a></p></div>` : ''}
                        ${address ? `<div class="infowindow-detail"><div class="infowindow-detail-img"><svg xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" viewBox="0 0 28 28"><path stroke="currentColor" stroke-width="1.75" d="M23.333 11.667c0 5.154-9.334 14-9.334 14s-9.333-8.846-9.333-14a9.333 9.333 0 1 1 18.667 0Z"/><path fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.75" d="M13.999 12.833a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333"/></svg></div><p>${address}</p></div>` : ''}
                    </div>
                </div>
            `,
        });

        marker.addListener('click', () => {
            map.panTo(marker.getPosition());
            infoWindow.open({ anchor: marker, map });
            map.panBy(0, -(mapElement.offsetHeight * 0.25));
        });
    });
});